
interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image_url: string;
  category_id: string;
  active: boolean;
  in_stock: boolean;
  image_position?: 'top' | 'center' | 'bottom';
  categories?: {
    id: string;
    name: string;
    description: string;
  };
}

interface ProductCardProps {
  product: Product;
  onAddToCart: () => void;
  cartQuantity: number;
}

export default function ProductCard({ product, onAddToCart, cartQuantity }: ProductCardProps) {
  const imagePosition = product.image_position || 'center';
  const objectPositionClass = 
    imagePosition === 'top' ? 'object-top' :
    imagePosition === 'bottom' ? 'object-bottom' :
    'object-center';

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-pink-100 overflow-hidden hover:shadow-md transition-all duration-200 flex flex-col min-h-[320px] md:min-h-[350px]" data-product-shop>
      {/* Área da Imagem - Tamanho fixo */}
      <div className="relative w-full h-[180px] md:h-[200px] flex-shrink-0">
        <img 
          src={product.image_url} 
          alt={product.name}
          className={`w-full h-full object-cover ${objectPositionClass}`}
        />
        {cartQuantity > 0 && (
          <div className="absolute top-2 right-2 bg-pink-500 text-white text-xs px-2 py-1 rounded-full font-medium shadow-lg">
            {cartQuantity}
          </div>
        )}
        {!product.in_stock && (
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
            <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium">
              Indisponível
            </span>
          </div>
        )}
      </div>
      
      {/* Área de Conteúdo */}
      <div className="p-3 flex flex-col flex-1">
        {/* Nome do produto - altura fixa de 2 linhas */}
        <h3 className="font-semibold text-gray-800 text-sm mb-1 line-clamp-2 min-h-[2.5rem]">{product.name}</h3>
        
        {/* Descrição - altura fixa de 2 linhas */}
        <p className="text-gray-600 text-xs mb-2 line-clamp-2 min-h-[2.25rem]">{product.description}</p>
        
        {/* Preço e botão - sempre na base */}
        <div className="flex flex-col gap-2 mt-auto">
          <span className="text-pink-600 font-bold text-base">
            R$ {product.price.toFixed(2).replace('.', ',')}
          </span>
          
          <button
            onClick={onAddToCart}
            disabled={!product.in_stock}
            className={`w-full py-2 px-3 rounded-xl text-xs font-medium transition-all duration-200 flex items-center justify-center space-x-1 ${
              product.in_stock
                ? 'bg-gradient-to-r from-pink-400 to-purple-400 text-white hover:from-pink-500 hover:to-purple-500 shadow-sm hover:shadow-md'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            <i className={`text-sm ${product.in_stock ? 'ri-add-line' : 'ri-close-line'}`}></i>
            <span>{product.in_stock ? 'Adicionar' : 'Indisponível'}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
